import React, { PureComponent, Fragment } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import QuestionCateogoryStore from './QuestionCateogoryStore'
import SearchLayout from '../components/Layouts/Search'
import DataTable from '../components/DataTable'
import Button from '../UniformComponents/Button'
import Anchor from '../UniformComponents/Anchor'
import Tooltip from '../UniformComponents/Tooltip'
import QuestionCategoryEdit from './QuestionCategoryEdit'
import { removeQueryParam, setQueryParam, getQueryParam } from '../utils/helpers'

import '../assets/css/questionCategory.css'

const CATEGORY_PARAM = 'categoryId'

@observer
class QuestionCategory extends PureComponent {
    constructor(props) {
        super(props)
        const { store } = this.props
        this.state = {
            showModal: false,
            categoryId: 0,
        }
        this.questionCateogoryStore = new QuestionCateogoryStore(store)
        this.setColumns()
    }

    async componentDidMount() {
        const { questionCateogoryStore } = this
        const { store, location } = this.props

        store.breadcrumps = [
            {
                name: 'questioncategory',
                url: '/questioncategory',
                title: 'Question Category',
            },
        ]

        await questionCateogoryStore.initSearch()

        this.checkQueryParam(location)
    }

    checkQueryParam = (location) => {
        const categoryId = getQueryParam(location, CATEGORY_PARAM)
        if (categoryId === -1) return
        if (categoryId !== 0) {
            this.setState({ categoryId })
        }
        this.toggleModal()
    }

    setColumns = () => {
        this.columns = [
            {
                name: 'Description',
                key: 'description',
            },
            {
                name: '',
                key: 'categoryId',
                cellClass: 'center',
                dataTransform: (categoryId) => (
                    <div className="survey-btn-wrapper">
                        <Anchor
                            cssClass="icon-link-btn"
                            onClick={() => this.handleOpenModal(categoryId)}
                        >
                            <Tooltip
                                text={i18n.t('edit_question', 'Edit question')}
                                direction="bottom"
                            />
                            <i className="fa-light fa-edit" />
                        </Anchor>
                    </div>
                ),
            },
        ]
    }

    toggleModal = () => {
        this.setState((prevState) => ({
            showModal: !prevState.showModal,
        }))
    }

    handleOpenModal = (categoryId) => {
        const { location, history } = this.props

        setQueryParam(location, history, CATEGORY_PARAM, categoryId)
        this.setState({ categoryId })
        this.toggleModal()
    }

    handleCloseModal = () => {
        const { location, history } = this.props

        removeQueryParam(location, history, CATEGORY_PARAM)
        this.setState({ categoryId: 0 })
        this.toggleModal()
        this.questionCateogoryStore.resetFormState()
    }

    renderFilterOptions = () => (
        <div className="bottom-wrapper">
            <hr className="quest-cate-divider" />
            <Anchor cssClass="external-anchor" href="http://kb.explori.com/knowledge" target="_blank" isExternal>
                {i18n.t('home.bottombuttons.knowledgeBase')}
                <i className="fa-sharp fa-regular fa-arrow-right" />
            </Anchor>
        </div>
    )

    renderButtons = () => (
        <div className="right">
            <Button
                cssClass="add-button primary regular"
                onClick={() => { this.handleOpenModal(0) }}
                icon="fa-light fa-circle-plus"
                label={i18n.t('new_category', 'New category')}
            />
        </div>
    )

    renderTablePanel = () => {
        const { questionCateogoryStore } = this
        return (
            <DataTable
                store={questionCateogoryStore}
                dataSet={questionCateogoryStore.filteredList || []}
                columns={this.columns}
                inMemory
            />
        )
    }

    renderGuide = () => (
        <div dangerouslySetInnerHTML={{
            __html: i18n.t('questionCategory.introText'),
        }}
        />
    )

    render() {
        const { questionCateogoryStore, store } = this
        const { showModal, categoryId } = this.state
        return (
            <Fragment>
                <SearchLayout
                    pageTitle="Question category"
                    renderFilterOptions={this.renderFilterOptions}
                    renderButtons={this.renderButtons}
                    renderTablePanel={this.renderTablePanel}
                    renderGuide={this.renderGuide}
                    hideFilterAccordion
                    searchStore={questionCateogoryStore}
                />
                <QuestionCategoryEdit
                    store={store}
                    questionCateogoryStore={questionCateogoryStore}
                    categoryId={categoryId}
                    showModal={showModal}
                    handleCloseModal={this.handleCloseModal}
                />
            </Fragment>
        )
    }
}

export default QuestionCategory
